module.exports = __webpack_public_path__ + "assets/img/huadong.5504c391.png";